
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/sweet-shop-pos-billing-software",
      function () {
        return require("private-next-pages/outlet/sweet-shop-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/sweet-shop-pos-billing-software"])
      });
    }
  